import {
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Box,
  VStack,
  Text,
  Select,
  Input,
  Button,
  Flex,
  useToast,
} from "@chakra-ui/react";
import { useState } from "react";

interface SlotDetailsDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  restaurantData: any;
}

interface SlotData {
  timing: string;
  type: string;
  discount: string;
  tables: string;
}

const SlotDetailsDrawer: React.FC<SlotDetailsDrawerProps> = ({
  isOpen,
  onClose,
  restaurantData,
}) => {
  const toast = useToast();
  const [slotData, setSlotData] = useState<SlotData>({
    timing: "12:00 - 13:00",
    type: "Lunch",
    discount: "20",
    tables: "20",
  });

  const handleAddSlot = () => {
    // Add your logic here to save the slot
    toast({
      title: "Slot Added Successfully",
      status: "success",
      duration: 3000,
      isClosable: true,
    });
    onClose();
  };

  return (
    <Drawer isOpen={isOpen} placement="right" onClose={onClose} size="md">
      <DrawerOverlay />
      <DrawerContent>
        <DrawerCloseButton />
        <DrawerHeader borderBottomWidth="1px">Add booking slot</DrawerHeader>

        <DrawerBody>
          <VStack spacing={6} mt={4}>
            <Box width="100%">
              <Text mb={2} fontWeight="medium">
                Slot Timing
              </Text>
              <Select
                value={slotData.timing}
                onChange={(e) =>
                  setSlotData({ ...slotData, timing: e.target.value })
                }
              >
                <option value="12:00 - 13:00">12:00 - 13:00</option>
                <option value="13:00 - 14:00">13:00 - 14:00</option>
                <option value="14:00 - 15:00">14:00 - 15:00</option>
              </Select>
            </Box>

            <Box width="100%">
              <Text mb={2} fontWeight="medium">
                Type
              </Text>
              <Select
                value={slotData.type}
                onChange={(e) =>
                  setSlotData({ ...slotData, type: e.target.value })
                }
              >
                <option value="Lunch">Lunch</option>
                <option value="Dinner">Dinner</option>
                <option value="Breakfast">Breakfast</option>
              </Select>
            </Box>

            <Box width="100%">
              <Text mb={2} fontWeight="medium">
                Discount (%)
              </Text>
              <Input
                type="number"
                value={slotData.discount}
                onChange={(e) =>
                  setSlotData({ ...slotData, discount: e.target.value })
                }
                placeholder="Enter discount percentage"
              />
            </Box>

            <Box width="100%">
              <Text mb={2} fontWeight="medium">
                Total tables available
              </Text>
              <Input
                type="number"
                value={slotData.tables}
                onChange={(e) =>
                  setSlotData({ ...slotData, tables: e.target.value })
                }
                placeholder="Enter number of tables"
              />
            </Box>

            <Flex width="100%" justifyContent="flex-end" mt={8} gap={4}>
              <Button variant="outline" onClick={onClose}>
                Cancel
              </Button>
              <Button
                bg="#E24441"
                color="white"
                _hover={{ bg: "#d13e3b" }}
                onClick={handleAddSlot}
              >
                Save
              </Button>
            </Flex>
          </VStack>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};

export default SlotDetailsDrawer;
